import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SingleDatePickerModule } from 'Angular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';

import { YieldCurveComponent } from './yield-curve.component';

@NgModule({
    declarations: [YieldCurveComponent],
    imports: [CommonModule, FeatureNeededModule, LoadingSymbolModule, SimpleDropdownModule, SingleDatePickerModule],
    exports: [YieldCurveComponent],
})
export class YieldCurveModule {}
